import React, { useEffect, useState } from 'react';
import {
  Accordion,
  AccordionBody,
  AccordionHeader,
  AccordionItem,
} from 'reactstrap';
import styles from './AccordionShow.module.scss'
import SearchInFilters from './SearchInFilters/SearchInFilters';
import { useSearchParams } from 'react-router-dom';

export default function AccordionShow(props) {
  const [searchParams,setSearchParams] = useSearchParams();

    const [open, setOpen] = useState(`${props.openId && props.openId}`);
    const [apiFilters, setsetApiFilters] = useState(props.data.property_items);
    const [filteredFeatures, setFilteredFeatures] = useState([]);
    const [urlFeatures, setUrlFeatures] = useState(searchParams.getAll(`${props.data.title}[]`.toLowerCase()));
    const [selectedFeatures, setSelectedFeatures] = useState([]);

    const toggle = (id) => {
      if (open === id) {
        setOpen('');
      } else {
        setOpen(id);
      }
    };

    const handleFeatureOnChange = (e) => {
      const { id, checked } = e.target;

      if(checked) {
        const arr = [...selectedFeatures, parseInt(id)];
        setSelectedFeatures(arr);
        searchParams.delete((`${props.data.title}[]`).toLowerCase());
        arr.forEach((item) => {
          searchParams.append(`${props.data.title}[]`.toLowerCase(), item.toString());
        });
        searchParams.delete('page');
        setSearchParams(searchParams);
      } 
      else {
        const arr = selectedFeatures.filter((e) => e !== parseInt(id));
        if(selectedFeatures.length > 1 ) {
          setSelectedFeatures(arr);
          searchParams.delete((`${props.data.title}[]`).toLowerCase());
          arr.forEach((item) => {
            searchParams.append(`${props.data.title}[]`.toLowerCase(), item.toString());
          });
        } else {
          setSelectedFeatures([]);
          searchParams.delete((`${props.data.title}[]`).toLowerCase());
        }
        searchParams.delete('page');
        setSearchParams(searchParams);
      }
    }

    const filterItems  = (searchText) => {
      const filteredItems = apiFilters.filter((filter) => 
        filter.value.toLowerCase().includes(searchText.toLowerCase())
        );

        setFilteredFeatures(filteredItems);
    }

    useEffect(() => {
      if (Object.keys(apiFilters).length > 0) {
        setFilteredFeatures(apiFilters);
      }
    },[apiFilters]);

    useEffect(() => {
      if(urlFeatures.length > 0) {
        let numberUrlFeature = [];
        for( let i = 0; i < urlFeatures.length; i++) {
          numberUrlFeature.push(parseInt(urlFeatures[i]));
        }
        setUrlFeatures(numberUrlFeature);
        setSelectedFeatures(numberUrlFeature)
      }
    },[]);

    useEffect(() => {
      setUrlFeatures(searchParams.getAll(`${props.data.title}[]`.toLowerCase()));
    },[searchParams]);

    useEffect(() => {
      if(searchParams.size === 0) {
        setSelectedFeatures([]);
        setSearchParams("");
      }
    },[searchParams]);

  return (
    <div>
       <Accordion flush open={open} toggle={() => toggle(`${props.data.id}`)}  className={`mb-3 ${styles.lgtAccordion}`}>
          <AccordionItem className={`lgt-b-radius ${styles.lgtAccordionItem}`}>
            <AccordionHeader targetId={`${props.data.id}`} className={`${styles.lgtAccordionHeader}`}>
                {props.data.title}    
            </AccordionHeader> 
            <AccordionBody accordionId={`${props.data.id}`} className={`${styles.AccordionItemBody}`}>
              {
                props.data.property_items.length > 5 && (
                  <SearchInFilters  onChangeCallback={filterItems} />
                )
              }
              {
                filteredFeatures.length > 0 
                ? filteredFeatures.map((propertyItem) => (
                    <div 
                      className="form-check" 
                      key={propertyItem.id}
                    >
                      <input 
                        className="form-check-input" 
                        onChange={(e) => handleFeatureOnChange(e)}
                        type="checkbox" 
                        value={propertyItem.value} 
                        id={propertyItem.id} 
                        checked={selectedFeatures.includes(propertyItem.id)}
                       />
                      <label className="form-check-label">
                        {
                          propertyItem.value
                        }
                      </label>
                    </div>
                ))
                : <p className="fw-semibold">No Results</p>

              }                 
            </AccordionBody>
          </AccordionItem>
        </Accordion>
        
    </div>
  )
}
